
@if(orders) {
    @for (order of orders; track order.orderId) {
        <div class="p-5 my-4 border rounded-xl border-gray-300 ">
            <div class="flex flex-row justify-content-between">
                <div class="flex-1">
                    <div class="font-bold text-sm capitalize">{{order.orderNumber}}</div>
                    <div class="font-medium text-sm  capitalize text-green-600">{{order.orderStatus}}</div>
                    <div class="text-sm font-light capitalize">{{order.orderedDateTimeString | date: 'MMM d, y, h:mm a'}}</div>

                </div>
                <div class="flex gap-2">
                    <p-button
                        label="View Details"
                        severity="secondary" 
                        [outlined]="true"
                        [style]="{'border-color': '#4D7935', color: '#4D7935'}"
                        (click)="viewOrderDetails(order)" />
                </div>
            </div>
        </div>
    } @empty {
        <div class="p-4 pt-4">
            <p-message severity="info">No orders placed yet.</p-message>
            <!-- <div class="w-full flex items-center justify-center py-4">
                <p-button
                    [label]="'Notify Me'"
                    class="w-full [&_button]:w-full [&_button]:bg-slate-100 [&_button]:border-0 [&_button]:text-cyan-500" />
            </div> -->
        </div>
        
    }
} @else {
    <div class="flex w-full justify-center">
        <p-progress-spinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '50px', height: '50px' }" />
    </div>
}
